import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3aabd86"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "offcanvas offcanvas-start configure-model",
  id: "configuration-model"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-none" }, "Back to top")
], -1))
const _hoisted_5 = { class: "offcanvas-body" }
const _hoisted_6 = { class: "offcanvas-content-container" }
const _hoisted_7 = { class: "offcanvas-cookie" }
const _hoisted_8 = { class: "offcanvas-cookie-description" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "offcanvas-cookie-header" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "offcanvas-cookie-list" }
const _hoisted_13 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_14 = { class: "accordion-item" }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = ["onUpdate:modelValue", "id", "disabled", "onChange"]
const _hoisted_18 = ["for", "textContent"]
const _hoisted_19 = ["data-bs-target", "aria-controls"]
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "accordion-body" }
const _hoisted_22 = ["textContent"]
const _hoisted_23 = { class: "offcanvas-cookie-entry custom-checkbox" }
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = ["onUpdate:modelValue", "id", "disabled", "onChange"]
const _hoisted_26 = ["for", "textContent"]
const _hoisted_27 = { class: "offcanvas-cookie-button-group" }
const _hoisted_28 = ["textContent"]
const _hoisted_29 = ["textContent"]
const _hoisted_30 = { class: "container" }
const _hoisted_31 = { class: "row align-items-center" }
const _hoisted_32 = { class: "col cookie-permission-content" }
const _hoisted_33 = ["textContent"]
const _hoisted_34 = { class: "col-12 cookie-button-group col-md-auto pr-2" }
const _hoisted_35 = { class: "cookie-permission-button js-cookie-permission-button" }
const _hoisted_36 = ["textContent"]
const _hoisted_37 = { class: "js-cookie-configuration-button" }
const _hoisted_38 = ["textContent"]
const _hoisted_39 = { class: "js-cookie-accept-all-button" }
const _hoisted_40 = ["textContent"]

import { ref, onMounted, onUpdated, watchEffect, watch } from "vue"
import { useSystemAndContextStore } from "@/stores/systemAndContext.store"
import { _getValue, updateGoogleTagManagerConsent } from "@/helpers/common"

interface CookieEntry {
  snippet_name: string
  snippet_description?: string
  isRequired?: boolean
  entries?: CookieEntry[]
  accepted?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsentManager',
  setup(__props) {

const cookieConsentResponse = ref<CookieEntry[]>([])
let showBanner = ref(false)
const cookieEntries = ref<CookieEntry[]>([])
const systemAndContextStore = useSystemAndContextStore()
const contextManagerRef = ref(null)
const getContextManagerHeight = () => {
  if (contextManagerRef.value) {
    return contextManagerRef.value.offsetHeight
  }
  return 0
}
const updateDynamicStyle = () => {
  if (contextManagerRef.value) {
    document.body.style.paddingBottom = `${contextManagerRef.value.offsetHeight}px`
  }
}

onUpdated(() => {
  updateDynamicStyle()
})
onMounted(async () => {
  // Check if cookie consent is already saved
  const consentSaved = localStorage.getItem("cookieConsent")

  if (!consentSaved && false) {
    await initializeCookieConsentResponse()
    // Cookie consent not saved, show the banner
    showBanner.value = true
    // Initialize the cookieEntries with the consent response
    initializeCookieEntries()
  }
})

async function initializeCookieConsentResponse() {
  const currentContext = systemAndContextStore.getCurrentContext
  cookieConsentResponse.value = _getValue(currentContext, "extensions.eecom_gtm_consents", []).value

  if (cookieConsentResponse.value && cookieConsentResponse.value.length === 0) {
    if (_.isEmpty(systemAndContextStore.getCurrentContext)) {
      await systemAndContextStore.fetchCurrentContext()
    }

    const updatedContext = systemAndContextStore.getCurrentContext
    cookieConsentResponse.value = _getValue(updatedContext, "extensions.eecom_gtm_consents", []).value
  }
}

function initializeCookieEntries() {
  for (const group of cookieConsentResponse.value) {
    if (group.entries) {
      for (const entry of group.entries) {
        entry.accepted = true
      }
    }
    cookieEntries.value.push(group)
  }
}

const toggleGroupConsent = (consent: CookieEntry) => {
  if (!consent.entries) {
    return
  }
  consent.entries.forEach((entry) => {
    entry.accepted = consent.accepted
  })
}

const toggleConsent = (consent: CookieEntry) => {
  if (!consent.entries) {
    return
  }
  consent.accepted = consent.entries.every((entry) => entry.accepted)
}

const acceptAllCookies = () => {
  for (const group of cookieEntries.value) {
    group.accepted = true
    if (group.entries) {
      for (const entry of group.entries) {
        entry.accepted = true
      }
    }
  }
  saveConsent()
}

const rejectCookies = () => {
  for (const group of cookieEntries.value) {
    group.accepted = false
    if (group.entries) {
      for (const entry of group.entries) {
        entry.accepted = false
      }
    }
  }
  saveConsent()
}

const saveConsent = () => {
  // Filter the accepted entries
  const acceptedEntries = cookieEntries.value.reduce((acc: CookieEntry[], group) => {
    if (group.entries) {
      const accepted = group.entries.filter((entry) => entry.accepted)
      acc.push(...accepted)
    }
    return acc
  }, [])

  // Save the accepted entries to localStorage
  localStorage.setItem("cookieConsent", "1")

  // Hide the banner
  showBanner.value = false
  updateGoogleTagManagerConsent(acceptedEntries)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", {
          class: "offcanvas-title mb-0",
          textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.cookiePreferences'))
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", {
                textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.info'))
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", {
                  textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.ideas'))
                }, null, 8, _hoisted_11)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cookieConsentResponse.value, (consent, consentIndex) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "accordion-header",
                      id: 'flush-headingOne_' + consentIndex
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((consent.accepted) = $event),
                          id: 'flexCheckCheckedDisabled_' + consentIndex,
                          checked: "",
                          disabled: consent.isRequired,
                          onChange: ($event: any) => (toggleGroupConsent(consent))
                        }, null, 40, _hoisted_17), [
                          [_vModelCheckbox, consent.accepted]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: 'flexCheckCheckedDisabled_' + consentIndex,
                          textContent: _toDisplayString(_ctx.$t(consent.snippet_name))
                        }, null, 8, _hoisted_18)
                      ]),
                      _createElementVNode("button", {
                        class: "accordion-button collapsed",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": '#flush-collapseOne_' + consentIndex,
                        "aria-expanded": "false",
                        "aria-controls": 'flush-collapseOne_' + consentIndex
                      }, null, 8, _hoisted_19)
                    ], 8, _hoisted_15),
                    _createElementVNode("div", {
                      id: 'flush-collapseOne_' + consentIndex,
                      class: "accordion-collapse collapse"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        (consent.snippet_description)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              textContent: _toDisplayString(_ctx.$t(consent.snippet_description))
                            }, null, 8, _hoisted_22))
                          : _createCommentVNode("", true),
                        (consent.entries && consent.entries.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(consent.entries, (consentEntry, consentEntryIndex) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    "onUpdate:modelValue": ($event: any) => ((consentEntry.accepted) = $event),
                                    type: "checkbox",
                                    id: 'flexCheckCheckedDisabled_' + consentIndex + '_' + consentEntryIndex,
                                    checked: "",
                                    disabled: consent.isRequired,
                                    onChange: ($event: any) => (toggleConsent(consent))
                                  }, null, 40, _hoisted_25), [
                                    [_vModelCheckbox, consentEntry.accepted]
                                  ]),
                                  _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: 'flexCheckCheckedDisabled_' + consentIndex + '_' + consentEntryIndex,
                                    textContent: _toDisplayString(_ctx.$t(consentEntry.snippet_name))
                                  }, null, 8, _hoisted_26)
                                ])
                              ]))
                            }), 256))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_20)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "btn primary-btn btn-block js-offcanvas-cookie-accept-all",
                "data-bs-dismiss": "offcanvas",
                type: "submit",
                onClick: acceptAllCookies,
                textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.acceptAllCookies'))
              }, null, 8, _hoisted_28),
              _createElementVNode("button", {
                class: "btn primary-btn btn-block js-offcanvas-cookie-submit",
                "data-bs-dismiss": "offcanvas",
                type: "submit",
                onClick: saveConsent,
                textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.saveOnComputer'))
              }, null, 8, _hoisted_29)
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "contextManagerRef",
      ref: contextManagerRef,
      class: "cookie-permission-container"
    }, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("p", {
              class: "mb-2 mb-md-0",
              textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.info'))
            }, null, 8, _hoisted_33)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("span", _hoisted_35, [
              _createElementVNode("button", {
                class: "btn btn-outline-danger",
                type: "submit",
                onClick: rejectCookies,
                textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.reject'))
              }, null, 8, _hoisted_36)
            ]),
            _createElementVNode("span", _hoisted_37, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                "data-bs-target": "#configuration-model",
                "data-bs-toggle": "offcanvas",
                type: "submit",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showBanner) //@ts-ignore
 ? showBanner.value = false : showBanner = false)),
                textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.configure'))
              }, null, 8, _hoisted_38)
            ]),
            _createElementVNode("span", _hoisted_39, [
              _createElementVNode("button", {
                class: "btn primary-btn",
                type: "submit",
                onClick: acceptAllCookies,
                textContent: _toDisplayString(_ctx.$t('eecom-teamportal.consentManager.acceptAllCookies'))
              }, null, 8, _hoisted_40)
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _unref(showBanner)]
    ])
  ], 64))
}
}

})